<template>
  <div 
    class="switch" 
    @click="toggleSwitch"
    @mouseover="isHovered = true" 
    @mouseleave="isHovered = false"
  >
    <img 
      width="46"
      height="46"
      :src="currentIcon" 
      :alt="modelValue ? 'Switch On' : 'Switch Off'"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits } from 'vue';
import SwitchOn from '@/assets/images/icons/switch-on-lg.svg';
import SwitchOff from '@/assets/images/icons/switch-off-lg.svg';
import SwitchOnHover from '@/assets/images/icons/switch-on-lg-hover.svg';
import SwitchOffHover from '@/assets/images/icons/switch-off-lg-hover.svg';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  }
});

// const props = defineProps(['modelValue']);

const emit = defineEmits(['update:modelValue']);

const isActive = ref(props.modelValue);
const isHovered = ref(false);

watch(() => props.modelValue, (newVal) => {
  isActive.value = newVal;
});

const currentIcon = computed(() => {
  if (isActive.value) {
    return isHovered.value ? SwitchOnHover : SwitchOn;
  } else {
    return isHovered.value ? SwitchOffHover : SwitchOff;
  }
});

const toggleSwitch = () => {
  isActive.value = !isActive.value;
  emit('update:modelValue', isActive.value);
};
</script>

<style scoped>
.switch {
  width: 46px;
  height: 46px;
  cursor: pointer;
}
</style>
